var React = require('react');

function Message (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M12.9264235,0.569512308 C13.0271624,0.80912971 13.0243444,1.08031901 12.9186485,1.31774923 L7.96362836,12.448465 C7.75409285,12.9191553 7.20635046,13.1292046 6.74021148,12.9176232 C6.5455765,12.829278 6.38716114,12.6757221 6.29179249,12.4829596 L4.641,9.146 L10.15625,2.84375 L3.886,8.33 L0.497021393,6.54203927 C0.0440584535,6.30305297 -0.131277239,5.73853194 0.105398162,5.28114626 C0.204633999,5.08936862 0.366707683,4.93831157 0.563955944,4.85375804 L11.713025,0.074535979 C12.183458,-0.127122447 12.726715,0.0944860045 12.9264235,0.569512308 Z","id":"messages","fill":"#9AA4B4","fillRule":"nonzero"})));
}

Message.defaultProps = {"width":"13px","height":"13px","viewBox":"0 0 13 13","version":"1.1"};

module.exports = Message;

Message.default = Message;
